export default __webpack_public_path__ + "static/media/filter.93bf1fe4.svg";